export const DELAY_BEFORE_LOADING_STATE = 1000;
